<template>
  <div>
    <div class="pileDetail">
      <el-row :gutter="20">
        <el-col :span="8" :xs="24" :lg="8">
          <el-image :src="image" />
        </el-col>
        <el-col :span="16" :xs="24" :lg="16">
          <div class="details">
            <div class="specifier">
              <h1>充电桩 30kw-120kw直流</h1>
              <h3>产品特征 Product Features</h3>
              <ul>
                <li>采用大功率一体化设计方案，单机公路达400kw以上；</li>
                <li>全数字控制策略，具备BMS接口；人机交互界面友好</li>
                <li>预留4G通信，便于充电机监控</li>
                <li>采用独特的散热风道，散热效果更好</li>
                <li>具备VIN码识别功能、智能分配、有序充电、根据配电端符合波动来调整系统的充电策略。</li>
              </ul>
            </div>
            <div class="application">
              <h3>应用领域 Application Area</h3>
              <span>高档小区、停车场、高速公路服务区、市政空间等公共区域分布式充电站建设。</span>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-divider></el-divider>
    <div class="table">
<!--      <el-table-->
<!--        :span-method="objectSpanMethod"-->
<!--        :data="tableData"-->
<!--        style="width: 95%">-->
<!--        <el-table-column-->
<!--          prop="type"-->
<!--          label="产品分类"-->
<!--          width="360px">-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--          prop="c30"-->
<!--          label="30kw"-->
<!--          width="360px">-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--          prop="c60"-->
<!--          width="360px"-->
<!--          label="60kw">-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--          prop="c90"-->
<!--          width="360px"-->
<!--          label="90kw">-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--          prop="c120"-->
<!--          width="360px"-->
<!--          label="120kw">-->
<!--        </el-table-column>-->
<!--      </el-table>-->
    </div>
  </div>
</template>

<script>
export default {
  name: "Pile120kw",
  data(){
    return{
      image:require('../../../assets/images/production/pile/直流桩60-120kw.jpg'),
      tableData: [
        {
          type: '交流输入电压',
          c30: 'AC380±15%',
          c60: 'AC380±15%',
          c90: 'AC380±15%',
          c120: 'AC380±15%'
        },
        {
          type: '交流接入方式',
          c30: '三相五线',
          c60: '三相五线',
          c90: '三相五线',
          c120: '三相五线'
        },
        {
          type: '交流输入频率',
          c30: '50Hz±5%',
          c60: '50Hz±5%',
          c90: '50Hz±5%',
          c120: '50Hz±5%'
        },
        {
          type: '最大输出功率',
          c30: '30kw',
          c60: '60kw',
          c90: '90kw',
          c120: '120kw'
        },
        {
          type: '输出电压范围',
          c30: '200-750kw',
          c60: '200-750kw',
          c90: '200-750kw',
          c120: '200-750kw'
        },
        {
          type: '额定输出电流',
          c30: '40A/60A',
          c60: '80A/120A',
          c90: '120A/180A',
          c120: '160A/240A'
        },
        {
          type: '功率因素',
          c30: '≥0.98(50%负载以上)',
          c60: '≥0.98(50%负载以上)',
          c90: '≥0.98(50%负载以上)',
          c120: '≥0.98(50%负载以上)'
        },
        {
          type: '综合效率',
          c30: '≥95%(半载以上)',
          c60: '≥95%(半载以上)',
          c90: '≥95%(半载以上)',
          c120: '≥95%(半载以上)'
        },
        {
          type: '输出电压误差',
          c30: '在恒压模式下，直流输出电压正定误差不超过±0.5%',
          c60: '在恒压模式下，直流输出电压正定误差不超过±0.5%',
          c90: '在恒压模式下，直流输出电压正定误差不超过±0.5%',
          c120: '在恒压模式下，直流输出电压正定误差不超过±0.5%'
        },
        {
          type: '输出电流误差',
          c30: '在恒流模式下，输出直流电流设定值在额定值的20%~100%范围内，输出直流电流大于等于30A时，输出电流正定误差不超过±1%；在设定的输出直流电流小于30A时，输出电流正定误差不超过±0.3A',
          c60: '在恒流模式下，输出直流电流设定值在额定值的20%~100%范围内，输出直流电流大于等于30A时，输出电流正定误差不超过±1%；在设定的输出直流电流小于30A时，输出电流正定误差不超过±0.3A',
          c90: '在恒流模式下，输出直流电流设定值在额定值的20%~100%范围内，输出直流电流大于等于30A时，输出电流正定误差不超过±1%；在设定的输出直流电流小于30A时，输出电流正定误差不超过±0.3A',
          c120: '在恒流模式下，输出直流电流设定值在额定值的20%~100%范围内，输出直流电流大于等于30A时，输出电流正定误差不超过±1%；在设定的输出直流电流小于30A时，输出电流正定误差不超过±0.3A',
        },
        {
          type: '输出纹波系数',
          c30: '≤0.5%(有效值)；≤1%(峰值)',
          c60: '≤0.5%(有效值)；≤1%(峰值)',
          c90: '≤0.5%(有效值)；≤1%(峰值)',
          c120: '≤0.5%(有效值)；≤1%(峰值)',
        },
        {
          type: '启动冲击电流',
          c30: '≤输入电流的110%',
          c60: '≤输入电流的110%',
          c90: '≤输入电流的110%',
          c120: '≤输入电流的110%',
        },
        {
          type: '辅助电源',
          c30: '共低压辅助电源，为12V/10A与24V/10A两种模式可选，同时具有反向保护作用，波纹系数<1%',
          c60: '共低压辅助电源，为12V/10A与24V/10A两种模式可选，同时具有反向保护作用，波纹系数<1%',
          c90: '共低压辅助电源，为12V/10A与24V/10A两种模式可选，同时具有反向保护作用，波纹系数<1%',
          c120: '共低压辅助电源，为12V/10A与24V/10A两种模式可选，同时具有反向保护作用，波纹系数<1%',
        },
        {
          type: '整机尺寸',
          c30: '670*500*1670mm',
          c60: '670*500*1670mm',
          c90: '670*500*1670mm',
          c120: '670*500*1670mm',
        },
        {
          type: '防护等级',
          c30: 'IP54',
          c60: 'IP54',
          c90: 'IP54',
          c120: 'IP54',
        },
        {
          type: '工作温度',
          c30: '-20℃~+55℃',
          c60: '-20℃~+55℃',
          c90: '-20℃~+55℃',
          c120: '-20℃~+55℃',
        },
      ]
    }
  },
  methods:{
    objectSpanMethod({row,column,rowIndex,columnIndex}){
      //console.log(row,column,rowIndex,columnIndex)
    }
  }
}
</script>

<style lang="less" scoped>
.pileDetail{
  margin: 30px 50px;
  overflow: hidden;
  .el-image{
    float: left;
    max-height: 523.8px;
    max-width: 379.8px;
    padding: 20px 20px;
  }
  .details{
    float: left;
    margin: 20px 0;
    .specifier{
      width: 85%;
      //background-color: pink;
      ul{
        width: 80%;
        li{
          list-style: none;
          //background-color: yellowgreen;
          &:before{
            content: '';
            display: inline-block;
            width: 10px;
            height: 10px;
            background-color: #2c6bb6;
            border-radius: 50%;
            margin-right: 5px;
          }
        }
      }
    }
    .application{
      float: left;
      width: 85%;
      span{
        padding-left: 5px;
      }
    }
  }
  h1{
    padding: 0 5px;
    color: #2c6cb6;
  }
  h3{
    padding: 0 5px;
    color: #2c6cb6;
  }
}
.table{
  margin: 30px 50px;
}
</style>
